import {
  FileTextIcon,
  MicrophoneIcon,
  SparklesIcon,
} from "@/components/Icons";
import { useTranslation } from "react-i18next";
import { getStoreProofTranslationValues } from "@/product-proof";

const OnboardingReview = () => {
  const { t, i18n } = useTranslation();
  const storeProof = getStoreProofTranslationValues(
    i18n.resolvedLanguage || i18n.language,
  );

  return (
    <div className="flex w-full flex-col items-center text-center animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="relative mb-5 h-20 w-32" aria-hidden="true">
        <div className="absolute left-1 top-3 flex h-14 w-14 -rotate-6 items-center justify-center rounded-[20px] border border-[var(--fill-3)] bg-[var(--bg-primary)] text-[var(--accent)] shadow-lg">
          <MicrophoneIcon size={25} />
        </div>
        <div className="absolute left-[54px] top-[39px] h-0.5 w-6 bg-gradient-to-r from-[var(--accent)] to-[var(--premium-primary)]" />
        <div className="absolute right-1 top-1 flex h-16 w-16 rotate-3 items-center justify-center rounded-[22px] bg-gradient-to-tr from-[var(--premium-cta-start)] to-[var(--premium-cta-end)] text-white shadow-xl shadow-[var(--premium-cta-glow)]">
          <FileTextIcon size={27} />
          <SparklesIcon
            size={14}
            className="absolute -right-1 -top-1 text-[var(--premium-primary)]"
          />
        </div>
      </div>

      <span className="mb-3 rounded-full bg-[var(--accent)]/10 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.18em] text-[var(--accent)]">
        {t("onboarding.review.freePlanEyebrow")}
      </span>
      <h2 className="mb-3 max-w-[94%] text-balance text-3xl font-black tracking-tight text-[var(--text-primary)]">
        {t("onboarding.thankYouFreeTitle")}
      </h2>
      <p className="max-w-[94%] text-[15px] font-medium leading-relaxed text-[var(--text-secondary)]">
        {t("onboarding.thankYouFreeSubtitle")}
      </p>

      <div className="glass-tile mt-5 w-full rounded-3xl px-5 py-4 text-start">
        <p className="text-[13.5px] font-extrabold text-[var(--text-primary)]">
          {t("onboarding.review.freeTitle")}
        </p>
        <p className="mt-1 text-[12.5px] leading-relaxed text-[var(--text-secondary)]">
          {t("onboarding.review.freeBody")}
        </p>
      </div>

      <div className="mt-3 w-full rounded-3xl bg-[var(--fill-1)] px-5 py-4 text-start">
        <div className="flex items-center justify-between gap-3">
          <p className="text-[13px] font-semibold leading-relaxed text-[var(--text-primary)]">
            {t("onboarding.smallTeamNote")}
          </p>
          <span className="shrink-0 text-[11px] font-bold text-[var(--text-primary)]">
            <span aria-hidden="true">★★★★★</span>
            <span className="sr-only">
              {t("alertWidgetPaywall.rating", storeProof)}
            </span>
          </span>
        </div>
        <p className="mt-1.5 text-[12px] leading-relaxed text-[var(--text-secondary)]">
          {t("onboarding.review.ratingAsk")}
        </p>
        <p className="mt-1 text-[11.5px] leading-relaxed text-[var(--text-tertiary)]">
          {t("onboarding.review.storeNote")}
        </p>
      </div>
    </div>
  );
};

export default OnboardingReview;
